import { jsx as _jsx } from "react/jsx-runtime";
import { LayoutWrapper } from '@components';
export var Home = function () {
    return (_jsx(LayoutWrapper, { children: "Home" }));
};
